import UploadCode from "./UploadCode";

export default UploadCode;